module.exports = __webpack_public_path__ + "static/media/logo.f31b51da.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo.png
// module id = 127
// module chunks = 0